import Button from '@/components/@base/button';
import Props from '@/components/app/product/components/@shared/comments-header/add-comment-button/type';

import { pageLevelLocalization } from '@/constant/localization';

import AddIcon from '~/images/icons/add';

const { product: productLocalization } = pageLevelLocalization;

export default function AddCommentButton({ onAddCommentClick, ...props }: Props) {
  return (
    <Button
      Icon={
        <AddIcon
          width={15}
          height={15}
          fill='fill-[#81CF33] group-hover:fill-[#FFFFFF]'
          className='h-3 w-3 fill-current text-[#81CF33] transition-all duration-300 group-hover:fill-[#FFFFFF] md:h-[15px] md:w-[15px]'
        />
      }
      onClick={onAddCommentClick}
      className='group h-10 gap-1.5 bg-[#F5FBED] px-2.5 py-2.5 text-[12px] font-bold whitespace-nowrap! text-[#81CF33] transition-all hover:bg-[#81CF33] hover:text-[#FFFFFF] md:h-12 md:gap-[10px] md:px-[13px] md:text-[13px]'
      {...props}
    >
      {productLocalization.addComment}
    </Button>
  );
}
